import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import ApiPath from "./ConstantApi";
import {CustomerPortalModel} from './../Helpers/Interfaces/CustomerPortalModel';
import { setProductShowcaseAll } from "../Redux/Slices/CustomerPortalLayoutSlice";
import Config from "../Config";

export const CustomerPortalLayoutService = createApi({
  reducerPath: "CustomerPortalLayoutService",
  baseQuery: RtkBaseQueryWithReauth(Config.BASE_URL),
  tagTypes: ["CustomersLayout"],
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getHomeCustomersLayout: builder.query<any, void>({
      query: () => ({
        url: `${ApiPath.customerHomeLayoutList}`,
        method: "GET",
      }),
      transformResponse: (response: { data: CustomerPortalModel[] }) => {
        return (response.data && response.data.length ? response.data[0]:{})
      },
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data }:any = await queryFulfilled; // Wait for the query to resolve
          dispatch(setProductShowcaseAll(data)); // Dispatch setUser with the fetched user data
        } catch (error) {
          console.error('Error fetching user:', error);
        }
      },
      providesTags: ["CustomersLayout"],
    }),
  }),
});

export const {
  useGetHomeCustomersLayoutQuery,
} = CustomerPortalLayoutService;
